export default "__VITE_ASSET__DLKsZsLG__"